import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'tick-box-component',
    templateUrl: 'tick-box.component.html',
    styleUrls: ['tick-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TickBoxComponent {
  @Input() id: string;
  @Input() tickBox: TickBox;
  @Output() update: EventEmitter<boolean> = new EventEmitter<boolean>();

  updateTickItem(value: boolean): void {
    this.update.emit(value)
  }
}

export interface TickBox {
  name: string;
  slug: string;
  date: string;
  checked: boolean;
  enabled: boolean;
}
